import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT } from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";
import { DateUtil } from '../../../util/DateUtil';
import { DATE_FORMAT } from '../../../constants/constants';
import { UserUtil } from '../../../util/UserUtil';
export class SolicitudesEjecutadasAdminPage extends BasePage {

  createPageProperties = (pageApi) => {
    return {
      title: 'SOLICITUDES EJECUTADAS'
    };
  }

  renderPage(pageApi) {
    const getGridSoli_asignadas = () => pageApi.getComponent('grid');
    const getFormSoli_asignadas = () => pageApi.getComponent('form');

    const formSoli_asignadasConfig = {
      layout: 'vertical',
      fields: [
        {type: 'select', name:'id_servicio', label:'Tipo Servicio', column: 2, load: {queryId: 128}, search: true },
        {name: 'nro_ss', label: 'Nro. Solicitud:', column: 2 },
        {type: 'select', name:'estado', label:'Estado', column: 4,  
          load: {
            dataList: [
              {label: 'Todos', value: 0},
              {label: 'Pendiente Aprobacion', value: 1},
              {label: 'Cerrado', value: 2},  
            ]
          }
        },  
        { type: 'date', name: 'fecha_desde', label: 'Desde', column: 2, value: DateUtil.getDate2(15), format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD },
        { type: 'date', name: 'fecha_hasta', label: 'Hasta', column: 2, value: DateUtil.getDate, format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD },
      ]
    };

    const gridSoli_ejecutadasConfig = {
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      load: {
        queryId: 898,
        hideMessage: true,
        hideMessageError: true,
        params: {
          id_user: UserUtil.getUserId(),
          fecha_desde: DateUtil.getDate2(15),
          fecha_hasta: DateUtil.getDate
        }
      },
      fields: [
        { name: 'servicio', label: 'Tipo Servicio' },
        { name: 'doc_nro_ss', label: 'Nro Solicitud' },
        { name: 'empresa', label: 'Cliente' }, 
        { name: 'referencia_proyecto', label: 'Proyecto' }, 
        { name: 'fecha_servicio', label: 'Fecha Inicio Servicio' },
        { name: 'fecha_final', label: 'Fecha Fin Servicio' },
        { name: 'estado', label: 'estado' },
        {
          ...COLUMN_DEFAULT.OPTIONS, label: 'Opciones', colSpan: 6, title: 'Ver Cadenas', color: 'blue',
          link: (value, row, index) => `/solicitudes-ejecutadas/solicitudes-ejecutadas/${row.id_doc}`,
          // fnVisible: (value, row, index) => {
          //     return RetornaVisulizacionBoton(row?.estado, 'editar')
          // }, 
        },
      ]
    };

    const barButtonSoli_asignadasconfig = {
      fields: [
        { ...BUTTON_DEFAULT.SEARCH, onClick: () => getGridSoli_asignadas().load({ 
          params: {
            ...getFormSoli_asignadas().getData(),
            id_user: UserUtil.getUserId(),
          }
        }) },
        { ...BUTTON_DEFAULT.CLEAR1, onClick: () => getFormSoli_asignadas().reset() },
      ]
    }

    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formSoli_asignadasConfig}
        />
        <BarButtonFw
          name="bar"
          getParentApi={pageApi.getApi}
          config={barButtonSoli_asignadasconfig}
        />
        <GridFw
          name="grid"
          getParentApi={pageApi.getApi}
          config={gridSoli_ejecutadasConfig}
        />
      </>
    )
  }
}
